import { GET_PROCESS_EXPORT_CSV_FILE } from "./types";

export default {
  [GET_PROCESS_EXPORT_CSV_FILE]: (state) => state.process_export_csv,
};
